// 외주 의뢰서 — 「월별 요약」 (미리보기 v11 L4). 집계 = 케이스 1건, 기준 = 보낸 날(KST). 금액은 업체가 발행한 명세서 기준(대표만 — 직원 서류 잠금)
import React, { useEffect, useMemo, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { MF_KIND_LABEL, mfMsOf } from '../../services/outsourceMfApi';
import { S, KindChip } from './mfUi';

const DAY = 86400000;
const kstMonth = (ms) => new Date(ms + 9 * 3600 * 1000).toISOString().slice(0, 7);
const shiftMonth = (ym, n) => { const [y, m] = ym.split('-').map(Number); const d = new Date(Date.UTC(y, m - 1 + n, 1)); return d.toISOString().slice(0, 7); };

function Bars({ title, sub, rows }) {
    const max = Math.max(1, ...rows.map((r) => r.n));
    return (
        <div style={{ marginBottom: 14 }}>
            <div style={{ fontWeight: 700, fontSize: 14 }}>{title}</div>
            <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 8 }}>{sub}</div>
            {rows.length === 0 && <div style={{ fontSize: 12.5, color: '#94a3b8' }}>{'없음'}</div>}
            {rows.map((r) => (
                <div key={r.label} style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '6px 0' }}>
                    <span style={{ width: 120, fontSize: 13, color: '#334155', flexShrink: 0 }}>{r.label}</span>
                    <div style={{ flex: 1, height: 10, background: '#f1f5f9', borderRadius: 5 }}><div style={{ width: `${(r.n / max) * 100}%`, height: '100%', background: '#6366f1', borderRadius: 5 }} /></div>
                    <b style={{ width: 44, textAlign: 'right', fontSize: 13 }}>{r.n}{'건'}</b>
                </div>
            ))}
        </div>
    );
}

export default function MfMonthly({ orders, cadRows = [], me }) {   // cadRows: 10-30 CAD 외주 삭제로 늘 빈 배열
    const [month, setMonth] = useState(kstMonth(Date.now()));
    const [amounts, setAmounts] = useState(null);   // { vendorId: {amount, unissued:boolean} } — 대표만
    useEffect(() => {
        if (!me.isOwner) return;
        let on = true;
        getDocs(query(collection(db, 'transactionStatements'), where('toUserId', '==', me.companyId), where('kind', '==', 'outsource_mf')))
            .then((s) => {
                const m = {};
                s.docs.forEach((d) => {
                    const x = d.data();
                    if (x.outsourceMfMonth !== month) return;
                    const k = x.fromUserId;
                    m[k] = m[k] || { amount: 0, issued: 0, draft: 0 };
                    if (x.status === 'draft') m[k].draft += 1; else { m[k].issued += 1; m[k].amount += Number(x.totalAmount) || 0; }
                });
                if (on) setAmounts(m);
            })
            .catch((e) => { console.error('[외주 월별] 명세서 금액 읽기 실패 code=%s', e && e.code); if (on) setAmounts(null); });
        return () => { on = false; };
    }, [me.isOwner, me.companyId, month]);

    const mine = useMemo(() => orders.filter((o) => kstMonth(mfMsOf(o.createdAt) || 0) === month), [orders, month]);
    const cad = useMemo(() => (cadRows || []).filter((r) => kstMonth(mfMsOf(r.requestedAt) || mfMsOf(r.createdAt) || 0) === month), [cadRows, month]);
    const leadDays = (list) => {
        const xs = list.filter((o) => o.firstDownloadedAt).map((o) => ((mfMsOf(o.firstDownloadedAt) - mfMsOf(o.createdAt)) / DAY));
        return xs.length ? (xs.reduce((a, b) => a + b, 0) / xs.length).toFixed(1) : '-';
    };
    const unopened = mine.filter((o) => o.status === 'pending').length;
    const cancelled = mine.filter((o) => ['rejected', 'cancelled'].includes(o.status));
    const byVendor = {};
    mine.forEach((o) => { const k = o.toUserId; byVendor[k] = byVendor[k] || { name: o.toName, kind: o.kind, list: [] }; byVendor[k].list.push(o); });
    const count = (list, key) => { const m = {}; list.forEach((o) => { const v = key(o); if (v) m[v] = (m[v] || 0) + 1; }); return Object.keys(m).map((label) => ({ label, n: m[label] })).sort((a, b) => b.n - a.n); };
    const kindRows = Object.keys(MF_KIND_LABEL).map((k) => ({ label: MF_KIND_LABEL[k], n: k === 'cad' ? cad.length : mine.filter((o) => o.kind === k).length })).filter((r) => r.n > 0);
    const kindsUsed = new Set([...mine.map((o) => o.kind), ...(cad.length ? ['cad'] : [])]);
    const vendorsUsed = Object.keys(byVendor).length;

    const Stat = ({ title, big, sub }) => (
        <div style={{ ...S.card, flex: '1 1 200px', marginBottom: 0 }}>
            <div style={{ fontSize: 12.5, color: '#64748b' }}>{title}</div>
            <div style={{ fontSize: 26, fontWeight: 800, margin: '4px 0' }}>{big}</div>
            <div style={{ fontSize: 12, color: '#94a3b8' }}>{sub}</div>
        </div>
    );
    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                <button type="button" style={{ ...S.ghostBtn, padding: '6px 10px' }} onClick={() => setMonth((m) => shiftMonth(m, -1))}>{'‹'}</button>
                <span style={{ ...S.chipBtn(true), cursor: 'default' }}>{`${month.slice(0, 4)}년 ${Number(month.slice(5))}월`}</span>
                <button type="button" style={{ ...S.ghostBtn, padding: '6px 10px' }} onClick={() => setMonth((m) => shiftMonth(m, 1))}>{'›'}</button>
                <span style={{ flex: 1 }} /><span style={{ fontSize: 12, color: '#94a3b8' }}>{'집계 = 케이스 1건 · 기준 = 보낸 날(KST)'}</span>
            </div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 12 }}>
                <Stat title="보낸 의뢰" big={`${mine.length + cad.length}건`} sub={`종류 ${kindsUsed.size}가지 · 업체 ${vendorsUsed}곳`} />
                <Stat title="보냄 → 제작 중 평균" big={`${leadDays(mine)}일`} sub="업체가 파일을 내려받기까지" />
                <Stat title="아직 확인 안 됨" big={`${unopened}건`} sub="업체가 열어 보지 않은 의뢰" />
                <Stat title="거절·취소" big={`${cancelled.length}건`} sub={cancelled[0] ? `사유: ${cancelled[0].rejectReason || cancelled[0].cancelReason || '-'}` : ''} />
            </div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-start' }}>
                <div style={{ ...S.card, flex: '1 1 520px', padding: 0, overflowX: 'auto' }}>
                    <div style={{ padding: '14px 16px 6px' }}><b>{'업체별'}</b><div style={{ fontSize: 12, color: '#94a3b8' }}>{me.isOwner ? '금액은 업체가 발행한 명세서 기준' : '금액은 대표 계정에서만 보입니다'}</div></div>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead><tr>{['업체', '케이스', '내려받기까지', '거절·취소', '명세서 금액'].map((h) => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                        <tbody>
                            {Object.keys(byVendor).length === 0 && <tr><td colSpan={5} style={{ ...S.td, color: '#94a3b8', textAlign: 'center' }}>{'이 달 보낸 의뢰가 없습니다'}</td></tr>}
                            {Object.keys(byVendor).map((k) => {
                                const v = byVendor[k];
                                const a = amounts && amounts[k];
                                return (
                                    <tr key={k}>
                                        <td style={S.td}><KindChip kind={v.kind} small />{' '}<b>{v.name}</b></td>
                                        <td style={S.td}>{v.list.length}{'건'}</td>
                                        <td style={S.td}>{leadDays(v.list)}{'일'}</td>
                                        <td style={S.td}>{v.list.filter((o) => ['rejected', 'cancelled'].includes(o.status)).length}{'건'}</td>
                                        <td style={S.td}>{!me.isOwner ? '-' : a && a.issued ? `${a.amount.toLocaleString()}원` : <span style={{ color: '#c2410c' }}>{'미발행'}</span>}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <div style={{ ...S.card, flex: '1 1 380px' }}>
                    <Bars title="종류별" sub="케이스 수" rows={kindRows} />
                    <Bars title="소재별" sub="케이스 수" rows={count(mine, (o) => (o.detail || {}).material)} />
                </div>
            </div>
            <div style={{ ...S.card, display: 'flex', gap: 24, flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 320px' }}><Bars title="CNC — 임플란트 시스템별" sub="케이스 수" rows={count(mine.filter((o) => o.kind === 'cnc'), (o) => (o.detail || {}).system)} /></div>
                <div style={{ flex: '1 1 320px' }}><Bars title="Metal print — 종류별" sub="케이스 수" rows={count(mine.filter((o) => o.kind === 'metal'), (o) => (o.detail || {}).item)} /></div>
            </div>
        </div>
    );
}
